import styled from "styled-components";
import device from "utils/device";

export const Tbl = styled.table`
  width: 100%;
  flex-grow: 1;
  @media ${device.tablet} {
    thead, tbody tr {
      width: 100%;
    }

    thead th {
      position: sticky;
      top: 0;
      z-index: 1;
      background: ${p => p.showHorizontalShadow ? '#fafafa' : ''};
      box-shadow: ${p => p.showHorizontalShadow && '0px 5px 10px -2px rgba(0, 0, 0, 0.08)'};
    }


    thead th {
      padding-left: ${p => p.notPadded ? '0px' : '20px'};
    }

    thead th:first-child {
      position: sticky;
      left: 0;
      padding-left: 0px;
      background: ${p => p.showVerticalShadow || p.showHorizontalShadow ? '#fafafa' : ''};
      box-shadow: ${p => p.showVerticalShadow && '5px 0px 10px -2px rgba(0, 0, 0, 0.08)'};
      z-index: 2;
    }

    tbody th {
      position: sticky;
      left: 0;
      background: ${p => p.showVerticalShadow ? '#fafafa' : ''};
      z-index: 1;
      box-shadow: ${p => p.showVerticalShadow && '5px 0px 10px -2px rgba(0, 0, 0, 0.08)'};
    }

    tbody td {
      padding-left: ${p => p.notPadded ? '0px' : '20px'};
    }
  }
`;